"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FunnelChart = require("./FunnelChart");
Object.keys(_FunnelChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FunnelChart[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FunnelChart[key];
    }
  });
});